import gql from 'graphql-tag';

export const edit = gql`mutation EditClient($id: ID!, $client: ClientInput!) {
    editClient(id: $id, client: $client) {
        id
        name

        currency {
            id
            name
            isoCode
            symbol
        }

        address
        gitCode
        phone
        fax
        email
        vatRate
        comments
    }
}`;

export const add = gql`mutation CreateClient($client: ClientInput!) {
    createClient(client: $client) {
        id
        name

        currency {
            id
            name
            isoCode
            symbol
        }

        address
        gitCode
        phone
        fax
        email
        vatRate
        comments
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/client.js